var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 29.8889C16.5556 22.1111 21 15.4444 21 11C21 8.34784 19.9464 5.8043 18.0711 3.92893C16.1957 2.05357 13.6522 1 11 1C8.34784 1 5.8043 2.05357 3.92893 3.92893C2.05357 5.8043 1 8.34784 1 11C1 15.4444 5.44444 22.1111 11 29.8889Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4446 11C15.4446 12.1787 14.9763 13.3092 14.1428 14.1427C13.3093 14.9762 12.1788 15.4444 11.0001 15.4444C9.82137 15.4444 8.69091 14.9762 7.85741 14.1427C7.02392 13.3092 6.55566 12.1787 6.55566 11C6.55566 9.82125 7.02392 8.69078 7.85741 7.85729C8.69091 7.02379 9.82137 6.55554 11.0001 6.55554C12.1788 6.55554 13.3093 7.02379 14.1428 7.85729C14.9763 8.69078 15.4446 9.82125 15.4446 11Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.8e7e505ac71bef139dc273e39ba80afd.svg";
export { ForwardRef as ReactComponent };